import { render } from "./VerifyCode.vue?vue&type=template&id=5b393f12&scoped=true&ts=true"
import script from "./VerifyCode.vue?vue&type=script&lang=ts"
export * from "./VerifyCode.vue?vue&type=script&lang=ts"

import "./VerifyCode.vue?vue&type=style&index=0&id=5b393f12&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b393f12"]])

export default __exports__